import React, { useState, useEffect } from "react"
import Header from "../../layouts/Header"
import BackIcon from "../../components/BackIcon"
import { ThemeProvider, styled, createTheme } from "@mui/material/styles"
import {
  useMediaQuery,
  useTheme,
  Box,
  Tabs,
  Tab,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  InputLabel,
  TableBody,
  Grid,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  List,
  CardContent,
  Card,
  Button,
  ListItem,
  Checkbox,
  Divider,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  TextField,
  Tooltip,
  IconButton,
  Modal,
  Paper,
  Fab,
} from "@mui/material"
import Swal from "sweetalert2"
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart"
import CustomTooltip from "../../components/ToolTip"
import Obturador from "./components/Obturador"
import DescriptionIcon from "@mui/icons-material/Description"
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag"
import ProductCard from "./components/ProductCard"
import EjecutarAccionIcon from "../../assets/iconos/EjecutarAccion.ico"
import { FcPlus, FcSearch } from "react-icons/fc"
import ModalCreateClient from "./components/ModalCreateClient"
import ExpandMore from "@mui/icons-material/ExpandMore"
import CustomDatePicker from "../../components/CustomDatePicker"
import CustomTextFieldReadable from "../../components/CustomTextFieldReadable"
import CustomHelperDetail from "./components/CustomHelperDetail"
import ModalSearchClient from "./components/ModalSearchCliente"
import CustomTextField from "../../components/CustomTextField"
import { whenTransitionDone } from "@fullcalendar/core/internal"
import DetallesTab from "./components/DetallesTab"
import ShoppingDetail from "./components/ShoppingDetail"
import CustomAutocomplete from "../../components/CustomAutocomplete"
import { useQuery } from "@tanstack/react-query"
import fetchwrapper from "../../services/interceptors/fetchwrapper"
import CustomBackdrop from "../../components/CustomBackdrop"
import ModalSearchIntegrador from "./components/ModalSearchIntegrador"
import ModalSearchProyecto from "./components/ModalSearchProyecto"
import { prod } from "mathjs"
import ModalCreateIntegrador from "./components/ModalCreateIntegrador"
const StyledRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(8),
  flexGrow: 1,
  padding: "0 16px",
  height: "100vh",
}))

const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87", // Cambia el color secundario a verde azulado
    },
  },
})
const styles = {
  accordionSummary: {
    backgroundColor: "rgb(25, 108, 135)",
    color: "white",
    fontWeight: "bolder",
  },
  tabsContainer: {
    maxWidth: "100%",
    margin: "0 auto",
    fontFamily: "Arial, sans-serif",
  },
  heading: {
    fontSize: "32px",
    fontWeight: "bolder",
  },
  tabButtons: {
    display: "flex",
    gap: "4px",
    marginTop: "14px",
  },
  tabButton: {
    padding: "10px 20px",
    cursor: "pointer",
    border: "none",
    backgroundColor: "#f1f1f1",
    borderRadius: "10px 10px 0 0",
    transition: "background-color 0.3s",
    marginRight: "8px",
  },
  activeTab: {
    fontWeight: "bold",
    backgroundColor: "rgb(25, 108, 135)",
    borderRadius: "10px 10px 0 0",
    color: "white",
  },
  subtabsContainer: {
    maxWidth: "100%",
    margin: "0 auto",
    fontFamily: "Arial, sans-serif",
  },
  tabContent: {
    padding: "20px",
    border: "1px solid #ddd",
    borderRadius: "0 0 10px 10px",
    backgroundColor: "#f9f9f9",
    maxWidth: "100%",
    height: "100%",
  },
  tabContentHeading: {
    marginTop: 0,
    fontWeight: "bold",
    fontSize: "24px",
    color: "white",
  },
}
const FloatingMenu = () => {
  const menuItems = [
    { icon: <DescriptionIcon />, label: "Información", sectionId: "informacion" },
    { icon: <ShoppingBagIcon />, label: "Productos", sectionId: "productos" },
  ]

  const scrollToSection = (id) => {
    const element = document.getElementById(id)
    if (element) {
      element.scrollIntoView({ behavior: "smooth" })
    }
  }

  return (
    <Box
      sx={{
        position: "fixed",
        top: "50%",
        right: "10px",
        transform: "translateY(-50%)",
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        borderRadius: "30px",
        padding: "10px",
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        zIndex: 1000,
      }}
    >
      <List>
        {menuItems.map((item, index) => (
          <ListItem key={index} sx={{ padding: 0, marginBottom: "10px" }}>
            <Tooltip title={<span style={{ fontSize: "16px" }}>{item.label}</span>} placement="left">
              <IconButton
                onClick={() => scrollToSection(item.sectionId)}
                sx={{
                  color: "#666",
                  backgroundColor: "white",
                  "&:hover": { backgroundColor: "#f0f0f0" },
                  boxShadow: index === 0 ? "0 4px 8px rgba(255, 0, 0, 0.2)" : "none",
                  "&:nth-of-type(1)": { color: "#E91E63" },
                }}
              >
                {item.icon}
              </IconButton>
            </Tooltip>
          </ListItem>
        ))}
      </List>
    </Box>
  )
}
// Inside your ProductosServicios component

const CustomerAdditionalInfo = () => (
  <Grid container spacing={2}>
    <Grid item xs={6}>
      <TextField label="Región" variant="outlined" fullWidth />
    </Grid>
    <Grid item xs={6}>
      <TextField label="Provincia" variant="outlined" fullWidth />
    </Grid>
    <Grid item xs={6}>
      <TextField label="Zona" variant="outlined" fullWidth />
    </Grid>
    <Grid item xs={6}>
      <TextField label="Cantón" variant="outlined" fullWidth />
    </Grid>
    <Grid item xs={12}>
      <TextField label="Dirección 2" variant="outlined" fullWidth />
    </Grid>
    <Grid item xs={6}>
      <TextField label="Profesión" variant="outlined" fullWidth />
    </Grid>
    <Grid item xs={6}>
      <TextField label="Est. Civil" variant="outlined" fullWidth />
    </Grid>
    <Grid item xs={6}>
      <TextField label="Fono/Fax" variant="outlined" fullWidth />
    </Grid>
    <Grid item xs={6}>
      <TextField label="Website" variant="outlined" fullWidth />
    </Grid>
    <Grid item xs={12}>
      <TextField label="Email" variant="outlined" fullWidth />
    </Grid>
    <Grid item xs={6}>
      <TextField label="Tipo/Cliente" variant="outlined" fullWidth />
    </Grid>
    <Grid item xs={6}>
      <TextField label="Cónyuge" variant="outlined" fullWidth />
    </Grid>
  </Grid>
)

const CreditGrantingInfo = () => (
  <Grid container spacing={2}>
    <Grid item xs={6}>
      <TextField label="Lista de Precios de Defecto" variant="outlined" fullWidth />
    </Grid>
    <Grid item xs={6}>
      <TextField label="Cupo" variant="outlined" fullWidth />
    </Grid>
    <Grid item xs={6}>
      <TextField label="Plazo Máximo en Días" variant="outlined" fullWidth />
    </Grid>
    <Grid item xs={6}>
      <TextField label="Utilizado" variant="outlined" fullWidth />
    </Grid>
    <Grid item xs={6}>
      <Checkbox /> <Typography display="inline">Aplica IVA</Typography>
    </Grid>
    <Grid item xs={6}>
      <TextField label="Pedidos Aprobados" variant="outlined" fullWidth />
    </Grid>
    <Grid item xs={6}>
      <TextField label="Bloqueo" variant="outlined" fullWidth />
    </Grid>
    <Grid item xs={6}>
      <TextField label="Disponible" variant="outlined" fullWidth />
    </Grid>
    <Grid item xs={6}>
      <TextField label="Oficial de Crédito" variant="outlined" fullWidth />
    </Grid>
    <Grid item xs={6}>
      <TextField label="Actividad Económica" variant="outlined" fullWidth />
    </Grid>
    <Grid item xs={6}>
      <TextField label="Sector" variant="outlined" fullWidth />
    </Grid>
    <Grid item xs={6}>
      <TextField label="Día de Pago" variant="outlined" fullWidth />
    </Grid>
    <Grid item xs={6}>
      <TextField label="Días de demora en proceso de Pago" variant="outlined" fullWidth />
    </Grid>
    <Grid item xs={6}>
      <TextField label="Día hasta que se le puede entregar Facturas" variant="outlined" fullWidth />
    </Grid>
  </Grid>
)

const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: "none",
  color: "black",
  minWidth: "80px",
  borderRadius: "20px",
  "&.Mui-selected": {
    color: "white",
    backgroundColor: "rgb(25, 108, 135)",
  },
  transition: "all 0.5s ease",
  [theme.breakpoints.down("sm")]: {
    width: "100%", // Full width on mobile
    fontSize: "0.9rem",
    textAlign: "center", // Center align for a cleaner look on mobile
  },
}))

const StyledTabs = styled(Tabs)(({ theme }) => ({
  borderRadius: "25px",
  padding: "5px",
  maxWidth: "100%",
  backgroundColor: "#f1f1f1",
  "& .MuiTabs-indicator": {
    display: "none", // Oculta el indicador de pestaña para un aspecto personalizado
  },
  "& .MuiTab-root": {
    transition: "transform 0.7s ease-in-out",
  },
}))

const PaymentScreen = () => {
  return (
    <Box sx={{ padding: "20px" }}>
      {/* Sección de Parámetros de Pago */}
      <Box sx={{ marginBottom: "20px" }}>
        <Typography variant="h6" gutterBottom>
          Parámetros de Pago
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6} sm={4}>
            <TextField label="Forma de Pago" variant="outlined" fullWidth />
          </Grid>
          <Grid item xs={6} sm={4}>
            <TextField label="Tipo de Pago" variant="outlined" fullWidth />
          </Grid>
          <Grid item xs={6} sm={4}>
            <TextField label="Dividendos" variant="outlined" fullWidth />
          </Grid>
          <Grid item xs={6} sm={4}>
            <TextField label="Días" variant="outlined" fullWidth />
          </Grid>
          <Grid item xs={6} sm={4}>
            <TextField label="% de Descuento" variant="outlined" fullWidth />
          </Grid>
          <Grid item xs={6} sm={4}>
            <Checkbox /> <Typography display="inline">Aplica Promoción</Typography>
          </Grid>
        </Grid>
      </Box>

      <Divider sx={{ margin: "20px 0" }} />

      {/* Sección de Aprobaciones */}
      <Box sx={{ marginBottom: "20px" }}>
        <Typography variant="h6" gutterBottom>
          Aprobaciones
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Checkbox /> <Typography display="inline">Aprobación Dpto. Crédito</Typography>
          </Grid>
          <Grid item xs={6}>
            <Checkbox /> <Typography display="inline">Aprobación Logística</Typography>
          </Grid>
        </Grid>
      </Box>

      <Divider sx={{ margin: "20px 0" }} />

      {/* Tabla de Dividendos */}
      <Box>
        <Typography variant="h6" gutterBottom>
          Tabla de Dividendos
        </Typography>
        <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Dividendo</TableCell>
                <TableCell>Fecha de Vencimiento</TableCell>
                <TableCell>Valor de la Cuota</TableCell>
                <TableCell>Saldo</TableCell>
                <TableCell>Referencia</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>1</TableCell>
                <TableCell>31/10/2024</TableCell>
                <TableCell>0.00</TableCell>
                <TableCell>0.00</TableCell>
                <TableCell>Forma de Pago: AL CONTADO</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  )
}

const PaymentDetailsScreen = () => {
  return (
    <Box sx={{ padding: "20px" }}>
      {/* Sección de Información de Cobro */}
      <Card sx={{ marginBottom: "20px", padding: "10px" }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Información de Cobro
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={6} sm={4}>
              <TextField label="Cobro con" variant="outlined" fullWidth />
            </Grid>
            <Grid item xs={6} sm={4}>
              <TextField label="Valor" variant="outlined" fullWidth />
            </Grid>
            <Grid item xs={6} sm={4}>
              <TextField label="Banco o Tarjeta de Crédito" variant="outlined" fullWidth />
            </Grid>
            <Grid item xs={6} sm={4}>
              <TextField label="N° Cuenta/Tarjeta/Crédito" variant="outlined" fullWidth />
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <Divider sx={{ margin: "20px 0" }} />

      {/* Sección de Detalles de Autorización y Transacción */}
      <Card sx={{ marginBottom: "20px", padding: "10px" }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Detalles de Autorización y Transacción
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={6} sm={4}>
              <TextField label="Referencia N° Autorización" variant="outlined" fullWidth />
            </Grid>
            <Grid item xs={6} sm={4}>
              <TextField label="Fecha/Cobro Vencimiento" variant="outlined" fullWidth />
            </Grid>
            <Grid item xs={6} sm={4}>
              <TextField label="Lote % Retención" variant="outlined" fullWidth />
            </Grid>
            <Grid item xs={6} sm={4}>
              <TextField label="N° Cheque o Transferencia" variant="outlined" fullWidth />
            </Grid>
            <Grid item xs={6} sm={4}>
              <TextField label="Transacción Bancaria" variant="outlined" fullWidth />
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <Divider sx={{ margin: "20px 0" }} />

      {/* Sección de Detalles Adicionales */}
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Detalles Adicionales
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={6} sm={4}>
              <TextField label="Tipo Crédito" variant="outlined" fullWidth />
            </Grid>
            <Grid item xs={6} sm={4}>
              <TextField label="Cuotas Diferidas" variant="outlined" fullWidth />
            </Grid>
            <Grid item xs={6} sm={4}>
              <TextField label="Valor Base" variant="outlined" fullWidth />
            </Grid>
            <Grid item xs={6} sm={4}>
              <TextField label="Valor IVA" variant="outlined" fullWidth />
            </Grid>
            <Grid item xs={6} sm={4}>
              <TextField label="Valor Interés" variant="outlined" fullWidth />
            </Grid>
            <Grid item xs={6} sm={4}>
              <TextField label="Valor Tarjeta" variant="outlined" fullWidth />
            </Grid>
            <Grid item xs={6} sm={4}>
              <TextField label="Adquiriente" variant="outlined" fullWidth />
            </Grid>
            <Grid item xs={6} sm={4}>
              <TextField label="Código Depósito en Bancos" variant="outlined" fullWidth />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  )
}
const ContainerCabecera = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(12, 1fr)",
  gridTemplateRows: "auto auto auto",
  gridTemplateAreas: `
    "ProformaInfo ProformaInfo Codigo Codigo Estado Estado FormaPago FormaPago FormaPago Vendedor Vendedor Vendedor"
    "ProformaInfo ProformaInfo FechaE FechaE FechaV FechaV Observacion Observacion Observacion Observacion Observacion Observacion"
  `,
  gap: "8px",
  alignItems: "center",
  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "repeat(12, 1fr)", // Mantén las columnas en el móvil
    gridTemplateAreas: `
      "ProformaInfo ProformaInfo ProformaInfo ProformaInfo ProformaInfo ProformaInfo ProformaInfo ProformaInfo ProformaInfo ProformaInfo ProformaInfo ProformaInfo"
      "Codigo Codigo Codigo Codigo Codigo Codigo Codigo Codigo Codigo Codigo Codigo Codigo"
      "Estado Estado Estado Estado Estado Estado Estado Estado Estado Estado Estado Estado"
      "FormaPago FormaPago FormaPago FormaPago FormaPago FormaPago FormaPago FormaPago FormaPago FormaPago FormaPago FormaPago"
      "Vendedor Vendedor Vendedor Vendedor Vendedor Vendedor Vendedor Vendedor Vendedor Vendedor Vendedor Vendedor"
      "FechaE FechaE FechaE FechaE FechaE FechaE FechaE FechaE FechaE FechaE FechaE FechaE"
      "FechaV FechaV FechaV FechaV FechaV FechaV FechaV FechaV FechaV FechaV FechaV FechaV"
      "Observacion Observacion Observacion Observacion Observacion Observacion Observacion Observacion Observacion Observacion Observacion Observacion"
    `,
  },
}))
const ContainerGarante = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(12, 1fr)",
  gridTemplateRows: "auto auto auto",
  gridTemplateAreas: `
    "Garante Garante Garante Garante Garante Garante Garante Garante Garante Garante Garante Garante"
     "Integrador Integrador Integrador Direccion Direccion Direccion Telefono Telefono Telefono Id Id Id"
     "Proyecto Proyecto Proyecto DireccionProyecto DireccionProyecto DireccionProyecto TelefonoProyecto TelefonoProyecto TelefonoProyecto IdProyecto IdProyecto IdProyecto"
  `,
  gap: "8px",
  alignItems: "center",
  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "repeat(12, 1fr)", // Mantén las columnas en el móvil
    gridTemplateAreas: `
      "Garante Garante Garante Garante Garante Garante Garante Garante Garante Garante Garante Garante"
      "Integrador Integrador Integrador Integrador Integrador Integrador Integrador Integrador Integrador Integrador Integrador Integrador"
      "Direccion Direccion Direccion Direccion Direccion Direccion Direccion Direccion Direccion Direccion Direccion Direccion"
      "Telefono Telefono Telefono Telefono Telefono Telefono Telefono Telefono Telefono Telefono Telefono Telefono"
      "Id Id Id Id Id Id Id Id Id Id Id Id"
      "Proyecto Proyecto Proyecto Proyecto Proyecto Proyecto Proyecto Proyecto Proyecto Proyecto Proyecto Proyecto"
      "DireccionProyecto DireccionProyecto DireccionProyecto DireccionProyecto DireccionProyecto DireccionProyecto DireccionProyecto DireccionProyecto DireccionProyecto DireccionProyecto DireccionProyecto DireccionProyecto"
      "TelefonoProyecto TelefonoProyecto TelefonoProyecto TelefonoProyecto TelefonoProyecto TelefonoProyecto TelefonoProyecto TelefonoProyecto TelefonoProyecto TelefonoProyecto TelefonoProyecto TelefonoProyecto"
      "IdProyecto IdProyecto IdProyecto IdProyecto IdProyecto IdProyecto IdProyecto IdProyecto IdProyecto IdProyecto IdProyecto IdProyecto"
    `,
  },
}))
const ContainerCliente = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(12, 1fr)",
  gridTemplateRows: "auto auto auto",
  gridTemplateAreas: `
    "Cliente Cliente Cliente Direccion Direccion Direccion Telefono Telefono Telefono Id Id Id"
  `,
  gap: "8px",
  alignItems: "center",
  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "repeat(12, 1fr)", // Mantén las columnas en el móvil
    gridTemplateAreas: `
      "Cliente Cliente Cliente Cliente Cliente Cliente Cliente Cliente Cliente Cliente Cliente Cliente"
      "Direccion Direccion Direccion Direccion Direccion Direccion Direccion Direccion Direccion Direccion Direccion Direccion"
      "Telefono Telefono Telefono Telefono Telefono Telefono Telefono Telefono Telefono Telefono Telefono Telefono"
      "Id Id Id Id Id Id Id Id Id Id Id Id"
    `,
  },
}))
const ContainerIntegrador = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(12, 1fr)",
  gridTemplateRows: "auto auto auto",
  gridTemplateAreas: `
    "Integrador Integrador Integrador Direccion Direccion Direccion Telefono Telefono Telefono Id Id Id"
  `,
  gap: "8px",
  alignItems: "center",
  width: "100%", // Asegura que ocupe todo el ancho disponible
  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "repeat(12, 1fr)", // Mantén las columnas en el móvil
    gridTemplateAreas: `
      "Integrador Integrador Integrador Integrador Integrador Integrador Integrador Integrador Integrador Integrador Integrador Integrador"
      "Direccion Direccion Direccion Direccion Direccion Direccion Direccion Direccion Direccion Direccion Direccion Direccion"
      "Telefono Telefono Telefono Telefono Telefono Telefono Telefono Telefono Telefono Telefono Telefono Telefono"
      "Id Id Id Id Id Id Id Id Id Id Id Id"
    `,
  },
}))
const ContainerTransportista = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(12, 1fr)",
  gridTemplateRows: "auto auto auto",
  gridTemplateAreas: `
    "Transportista Transportista Transportista Transportista Transportista Transportista Transportista Transportista Transportista Transportista Transportista Transportista"
    "DireccionEntrega DireccionEntrega DireccionEntrega DireccionEntrega DireccionEntrega DireccionEntrega DireccionEntrega DireccionEntrega DireccionEntrega DireccionEntrega DireccionEntrega DireccionEntrega"
  `,
  gap: "8px",
  alignItems: "center",
}))
const ContainerTab = styled(Box)({
  display: "grid",
  gridTemplateColumns: "repeat(12, 1fr)",
  gridTemplateRows: "auto auto auto",
  gridTemplateAreas: `
    "TabBox TabBox TabBox TabBox TabBox TabBox TabBox TabBox DetalleBox DetalleBox DetalleBox DetalleBox"
  `,
  gap: "8px",
  alignItems: "center",
  maxWidth: "100%",
  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "repeat(12, 1fr)", // Mantén las columnas en el móvil
    gridTemplateAreas: `
      "TabBox TabBox TabBox TabBox TabBox TabBox TabBox TabBox TabBox TabBox TabBox TabBox"
      "DetalleBox DetalleBox DetalleBox DetalleBox DetalleBox DetalleBox DetalleBox DetalleBox DetalleBox DetalleBox DetalleBox DetalleBox"
    `,
  },
})
const Cliente = styled(Box)({
  gridArea: "Cliente",
})
const TabI = styled(Box)({
  gridArea: "TabBox",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  maxWidth: "100%",
  height: "100%", // Ocupa el 100% de la altura del contenedor
})

const Pedido = styled(Box)({
  gridArea: "DetalleBox",
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  height: "100%",
  // Ocupa el 100% de la altura del contenedor
  overflowY: "auto", // Permite el scroll si el contenido es demasiado largo
})
const Direccion = styled(Box)({
  gridArea: "Direccion",
})
const DireccionProyecto = styled(Box)({
  gridArea: "DireccionProyecto",
})
const Garante = styled(Box)({
  gridArea: "Garante",
})
const Integrador = styled(Box)({
  gridArea: "Integrador",
})
const Proyecto = styled(Box)({
  gridArea: "Proyecto",
})
const Telefono = styled(Box)({
  gridArea: "Telefono",
})
const TelefonoProyecto = styled(Box)({
  gridArea: "TelefonoProyecto",
})
const Id = styled(Box)({
  gridArea: "Id",
})
const IdProyecto = styled(Box)({
  gridArea: "IdProyecto",
})
const ProformaInfo = styled(Box)({
  gridArea: "ProformaInfo",
})
const FechaE = styled(Box)({
  gridArea: "FechaE",
})
const FechaV = styled(Box)({
  gridArea: "FechaV",
})

const Codigo = styled(Box)({
  gridArea: "Codigo",
})
const Estado = styled(Box)({
  gridArea: "Estado",
})
const FormaPago = styled(Box)({
  gridArea: "FormaPago",
})
const Vendedor = styled(Box)({
  gridArea: "Vendedor",
})
const Observacion = styled(Box)({
  gridArea: "Observacion",
})
const Transportista = styled(Box)({
  gridArea: "Transportista",
})
const DireccionEntrega = styled(Box)({
  gridArea: "DireccionEntrega",
})

const ProductosServicios = () => {
  const [openPedidoModal, setOpenPedidoModal] = useState(false)

  const handleOpenPedidoModal = () => setOpenPedidoModal(true)
  const handleClosePedidoModal = () => setOpenPedidoModal(false)
  //  Estado de los productos seleccionados
  const [productosSeleccionados, setProductosSeleccionados] = useState([])
  const [openModalSearchClient, setOpenModalSearchClient] = useState(false)
  const handleOpenModalSearchClient = () => setOpenModalSearchClient(true)
  const handleCloseModalSearchClient = () => setOpenModalSearchClient(false)
  const [openModalSearchIntegrador, setOpenModalSearchIntegrador] = useState(false)
  const handleOpenModalSearchIntegrador = () => setOpenModalSearchIntegrador(true)
  const handleCloseModalSearchIntegrador = () => setOpenModalSearchIntegrador(false)
  const [openModalSearchProyecto, setOpenModalSearchProyecto] = useState(false)
  const handleOpenModalSearchProyecto = () => setOpenModalSearchProyecto(true)
  const handleCloseModalSearchProyecto = () => setOpenModalSearchProyecto(false)
  const [selectedClient, setSelectedClient] = useState(null)
  const [openModalCreateClient, setOpenModalCreateClient] = useState(false)
  const handleOpenModalCreateClient = () => setOpenModalCreateClient(true)
  const handleCloseModalCreateClient = () => setOpenModalCreateClient(false)
  const [openModalCreateIntegrador, setOpenModalCreateIntegrador] = useState(false)
  const handleOpenModalCreateIntegrador = () => setOpenModalCreateIntegrador(true)
  const handleCloseModalCreateIntegrador = () => setOpenModalCreateIntegrador(false)
  const [openModalCreateProyecto, setOpenModalCreateProyecto] = useState(false)
  const handleOpenModalCreateProyecto = () => setOpenModalCreateProyecto(true)
  const handleCloseModalCreateProyecto = () => setOpenModalCreateProyecto(false)
  const [expanded, setExpanded] = useState(false)
  const [expanded1, setExpanded1] = useState(false)
  const [expanded2, setExpanded2] = useState(false)
  const [valueTab, setValueTab] = React.useState(0)
  //  setea el objeto cliente seleccionado
  const handleClientSelected = (client) => {
    setSelectedClient(client) // Guarda el cliente seleccionado en el estado
    handleCloseModalSearchClient() // Cierra el modal después de seleccionar un cliente
  }
  const handleIntegradorSelected = (integrador) => {
    // Guarda el cliente seleccionado en el estado
    handleSetFiltros("integrador", integrador)
    handleCloseModalSearchIntegrador() // Cierra el modal después de seleccionar un cliente
  }
  const handleProyectoSelected = (pro) => {
    // Guarda el cliente seleccionado en el estado
    handleSetFiltros("proyecto", pro)
    handleCloseModalSearchProyecto() // Cierra el modal después de seleccionar un cliente
  }
  useEffect(() => {
    setSelectedClient(selectedClient)
    if (selectedClient) {
      setClienteNombre(selectedClient.clinombre)
      setIdCliente(selectedClient.cliruc)
      setTelefonoCliente(selectedClient.clitelef1)
      setDireccionCliente(selectedClient.clidirec)
      refetchGetAgencias()
      refetchGetProductos()
    }
    console.log("cliente seleccionado", selectedClient)
  }, [selectedClient])
  //  actualizar los valores de cliente

  //  funcion para agregar elementos a la lista de detalle
  useEffect(() => {
    if (productosSeleccionados.length > 0) {
      console.log(productosSeleccionados)
    }
  }, [productosSeleccionados])
  const [observacionCliente, setObservacionCliente] = useState("")
  const [idCliente, setIdCliente] = useState("")
  const [direccionCliente, setDireccionCliente] = useState("")
  const [telefonoCliente, setTelefonoCliente] = useState("")
  const [clienteNombre, setClienteNombre] = useState("")
  // se guarda descripcion y codigo de los nuevos objetos creados (cliente|integrador|proyecto)
  const [cabeceraProforma, setCabeceraProforma] = useState({})
  useEffect(() => {
    setClienteNombre(clienteNombre)
    setIdCliente(idCliente)
    setTelefonoCliente(telefonoCliente)
    setDireccionCliente(direccionCliente)
  }, [clienteNombre, idCliente, telefonoCliente, direccionCliente])
  const handleObservacionCliente = (event) => {
    setObservacionCliente(event.target.value)
  }

  useEffect(() => {
    setObservacionCliente(observacionCliente)
    console.log(observacionCliente)
  }, [observacionCliente])

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }
  const [value, setValue] = useState(0)

  const handleTabChange = (event, newValue) => {
    setValueTab(newValue)
  }
  const handleExpandAccordion = () => {
    setExpanded((prevExpanded) => !prevExpanded)
  }
  const handleExpandAccordion1 = (event, isExpanded) => {
    // Solo permitir que se expanda si clienteNombre tiene un valor válido
    if (clienteNombre && clienteNombre !== "") {
      setExpanded1((prevExpanded) => !prevExpanded)
    } else {
      // Opcional: Puedes mostrar un mensaje o alerta si deseas notificar al usuario
      Swal.fire({
        icon: "warning",
        title: "Cliente requerido",
        text: "Debes seleccionar un cliente.",
      })
    }
  }
  const handleExpandAccordion2 = () => {
    if (clienteNombre && clienteNombre !== "") {
      setExpanded2((prevExpanded) => !prevExpanded)
    } else {
      // Opcional: Puedes mostrar un mensaje o alerta si deseas notificar al usuario
      Swal.fire({
        icon: "warning",
        title: "Cliente requerido",
        text: "Debes seleccionar un cliente.",
      })
    }
  }
  const {
    data: dataFormasDePago = [],
    isError: dataFormasDePagoError,
    isFetching: isFetchingFormasDePago,
    isLoading: isLoadingFormasDePago,
    refetch: refetchGetAllFormasDePago,
  } = useGetAllFormasDePago()
  function useGetAllFormasDePago() {
    return useQuery({
      queryKey: ["FormasDePagoProforma"],
      queryFn: async () => {
        const response = await fetchwrapper("/facturacion_proformas/get_metodos_pago", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        })
        const result = await response.json()
        return result.data
      },
      keepPreviousData: true,
      enabled: true,
      onError: (error) => {
        console.log("Error fetching data", error)
      },
    })
  }
  const {
    data: dataVendedor = [],
    isError: dataVendedorError,
    isFetching: isFetchingVendedor,
    isLoading: isLoadingVendedor,
    refetch: refetchGetAllVendedor,
  } = useGetAllVendedores()
  function useGetAllVendedores() {
    return useQuery({
      queryKey: ["VendedoresProforma"],
      queryFn: async () => {
        const response = await fetchwrapper("/facturacion_proformas/get_vendedores", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        })
        const result = await response.json()
        return result.data
      },
      keepPreviousData: true,
      enabled: true,
      onError: (error) => {
        console.log("Error fetching data", error)
      },
    })
  }

  const [filtros, setFiltros] = useState({
    proyecto: {},
    transportista: {},
    integrador: {},
    metodoPago: {},
    vendedor: {},
    agencia: {},
    garante: {},
  })

  const handleSetFiltros = (key, value) => {
    if (filtros[key] !== value) {
      setFiltros((prev) => ({ ...prev, [key]: value }))
    }
  }
  useEffect(() => {
    console.log("filtros actuales", filtros)
  }, [filtros])

  const {
    data: dataAgencias = [],
    isError: dataAgenciasError,
    isFetching: isFetchingDataAgencias,
    isLoading: isLoadingAgencias,
    refetch: refetchGetAgencias,
  } = useGetAgenciasXCliente(selectedClient)
  function useGetAgenciasXCliente(cliente) {
    return useQuery({
      queryKey: ["proformaVentaAgenciaCliente", cliente],
      queryFn: async () => {
        const response = await fetchwrapper(`/facturacion_proformas/get_agencias_by_cliente`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ cliente: cliente.clicodigo }),
        })
        const result = await response.json()
        return result.agencias
      },
      enabled: !!selectedClient,
      onError: (error) => {
        console.log("Error fetching data", error)
      },
    })
  }

  const [prods, setProductos] = useState([])
  //  carga de imagenes
  const {
    data: dataProductos = [],
    isError: dataProductosError,
    isFetching: isFetchingDataProductos,
    isLoading: isLoadingProductos,
    refetch: refetchGetProductos,
  } = useGetProductos(selectedClient)
  function useGetProductos(cliente) {
    return useQuery({
      queryKey: ["productosProforma", cliente],
      queryFn: async () => {
        const response = await fetchwrapper(`/facturacion_proformas/get_top_30_articulos`, {
          method: "POST",
          body: JSON.stringify({ clicodigo: cliente.clicodigo }),
          headers: {
            "Content-Type": "application/json",
          },
        })
        console.log("llamada api", response.body)
        const result = await response.json()
        return result.data
      },
      enabled: !!selectedClient,
      onError: (error) => {
        console.log("Error fetching data", error)
      },
    })
  }

  useEffect(() => {
    if (dataProductos.length > 0) {
      setProductos(dataProductos)
      console.log("Productos cargados desde useGetProductos")
    }
  }, [dataProductos])
  useEffect(() => {
    if (prods.length > 0) {
      setProductos(prods)
    }
  }, [prods])
  const textIsAlreadyDecodedUbicacion = (infoRead, closeModalQr) => {
    console.log(infoRead)
  }
  const [valorBusqueda, setValorBusqueda] = useState("")
  const [respuestaBusqueda, setRespuestaBusqueda] = useState([])

  useEffect(() => {
    console.log("valorBusqueda")
    setValorBusqueda(valorBusqueda)
    console.log(valorBusqueda)
  }, [valorBusqueda])
  const {
    data: fetchedSpecificArticulo = [],
    isError: isLoadingSpecificArticuloError,
    isFetching: isFetchingSpecificArticulo,
    isLoading: isLoadingSpecificArticulo,
    refetch, // Añadir `refetch` de `useQuery`
  } = useGetSpecificArticulo()

  const handleSearchByCodigo = () => {
    if (!selectedClient) {
      Swal.fire({
        icon: "warning",
        title: "Cliente requerido",
        text: "Debes seleccionar un cliente primero",
      })
      return
    }
    console.log("valor de la busqueda antes del if", valorBusqueda)
    if (valorBusqueda && valorBusqueda.trim() !== "") {
      // Ejecuta la búsqueda específica
      console.log("antes de llamar a useGetSpecificArticulo")
      refetch()
      console.log("data", fetchedSpecificArticulo)
    } else {
      // Si el campo de búsqueda está vacío, trae todos los productos
      refetchGetProductos().then(() => {
        setProductos(dataProductos) // Fuerza la renderización con los datos actuales
        console.log("Productos recargados desde dataProductos", dataProductos)
      })
    }
  }

  useEffect(() => {
    if (fetchedSpecificArticulo.length > 0) {
      setRespuestaBusqueda(fetchedSpecificArticulo)
      setProductos(fetchedSpecificArticulo)
    }
  }, [fetchedSpecificArticulo])

  useEffect(() => {
    if (respuestaBusqueda.length > 0) {
      setRespuestaBusqueda(respuestaBusqueda)
      console.log(respuestaBusqueda)
    }
  }, [respuestaBusqueda])
  function useGetSpecificArticulo() {
    return useQuery({
      queryKey: ["busquedaXcodigoProforma", valorBusqueda],
      queryFn: async () => {
        const options = {
          method: "POST",
          body: JSON.stringify({ clicodigo: selectedClient?.clicodigo }),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
        // send api request here
        let response = await fetchwrapper(`/facturacion_proformas/get_specific_articulo/${valorBusqueda}`, options)
        response = await response.json()
        console.log("respuesta dentro de la llamada", response?.data)
        return response?.data
      },

      refetchOnWindowFocus: false,
      refetchOnReconnect: false, // Añade esta línea para evitar refetch al reconectar
      enabled: false,
    })
  }
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        ></div>
        <FloatingMenu />
        <Box className={StyledRoot}>
          <ContainerCabecera id="informacion">
            <CustomBackdrop
              isLoading={
                isLoadingProductos || isFetchingDataProductos || isLoadingSpecificArticulo || isFetchingSpecificArticulo
              }
            ></CustomBackdrop>
            <ProformaInfo>
              <FormControl>
                <FormLabel id="demo-radio-buttons-group-label"></FormLabel>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="proforma"
                  name="radio-buttons-group"
                  row={isMobile}
                >
                  <FormControlLabel value="proyecto" control={<Radio />} label="Proyecto" />
                  <FormControlLabel value="pedido" control={<Radio />} label="Pedido" />
                  <FormControlLabel value="proforma" control={<Radio />} label="Proforma" />
                </RadioGroup>
              </FormControl>
            </ProformaInfo>
            <Codigo>
              <CustomTextFieldReadable label="Codigo Proforma" value="PRA2400000201"></CustomTextFieldReadable>
            </Codigo>
            <Estado>
              <CustomTextFieldReadable label="Estado Proforma" value="Pendiente"></CustomTextFieldReadable>
            </Estado>
            <FechaE>
              <CustomDatePicker label="Fecha Emision" setValue={() => {}} isOptional={true} />
            </FechaE>
            <FechaV>
              <CustomDatePicker label="Fecha Emision" setValue={() => {}} isOptional={true} />
            </FechaV>
            <FormaPago>
              <CustomAutocomplete
                options={dataFormasDePago}
                selectedOption={Object.keys(filtros.metodoPago).length > 0 ? filtros.metodoPago : ""}
                setSelectedOption={(v) => {
                  handleSetFiltros("metodoPago", v)
                  console.log("pago", v)
                }}
                label={"Forma de Pago"}
              />
            </FormaPago>
            <Vendedor>
              <CustomAutocomplete
                options={dataVendedor}
                selectedOption={Object.keys(filtros.vendedor).length > 0 ? filtros.vendedor : ""}
                setSelectedOption={(v) => {
                  handleSetFiltros("vendedor", v)
                  console.log("v", v)
                }}
                label={"Vendedor"}
              />
            </Vendedor>
            <Observacion>
              <CustomTextField
                label="Observacion"
                value={observacionCliente}
                onChange={handleObservacionCliente}
              ></CustomTextField>
            </Observacion>
          </ContainerCabecera>
          {isMobile && <br></br>}
          <div style={{ paddingBottom: "10px" }}>
            <Accordion
              expanded={expanded}
              slotProps={{ heading: { component: "h2" } }}
              onChange={handleExpandAccordion}
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                style={styles.accordionSummary}
              >
                <Typography variant="h6" style={{ width: "100%", textAlign: "center" }}>
                  Datos de Cliente
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <ContainerCliente>
                  <Cliente>
                    <TextField
                      required
                      fullWidth
                      label="Cliente"
                      variant="outlined"
                      value={clienteNombre ?? ""}
                      InputProps={{
                        readOnly: true,

                        endAdornment: (
                          <div style={{ display: "flex" }}>
                            <Tooltip title="Buscar">
                              <IconButton
                                onClick={() => {
                                  handleOpenModalSearchClient()
                                }}
                              >
                                <FcSearch />
                              </IconButton>
                            </Tooltip>

                            <Tooltip title="Crear">
                              <IconButton
                                aria-label="delete"
                                onClick={() => {
                                  handleOpenModalCreateClient()
                                }}
                              >
                                <FcPlus />
                              </IconButton>
                            </Tooltip>
                          </div>
                        ),
                      }}
                    />
                    {/* *****************************************************
                                   MODAL BUSCAR CLIENTE
                  ****************************************************** */}
                    <ModalSearchClient
                      endpoint="/AsociacionProdAgencia/getCliente" // Ajusta este endpoint según tu backend
                      openModal={openModalSearchClient}
                      handleCloseModal={handleCloseModalSearchClient}
                      queryKey="clienteProformaSearchQuery"
                      perPage={10}
                      onItemSelected={handleClientSelected}
                      columnsTable={[
                        {
                          accessorKey: "ciacodigo",
                          header: "Ciacodigo",
                          size: 100,
                          Cell: ({ cell }) => {
                            const value = cell.getValue()
                            return <span>{value}</span>
                          },
                        },
                        {
                          accessorKey: "clicodigo",
                          header: "Código de Cliente",
                          size: 100,
                          Cell: ({ cell }) => {
                            const value = cell.getValue()
                            return <span>{value}</span>
                          },
                        },
                        {
                          accessorKey: "clinombre",
                          header: "Nombre del Cliente",
                          size: 250,
                          Cell: ({ cell }) => {
                            const value = cell.getValue()
                            return <span>{value}</span>
                          },
                        },
                        {
                          accessorKey: "cliruc",
                          header: "Número de identificación",
                          size: 150,
                          Cell: ({ cell }) => {
                            const value = cell.getValue()
                            return <span>{value}</span>
                          },
                        },
                        {
                          accessorKey: "clitelef1",
                          header: "Teléfono",
                          size: 100,
                          Cell: ({ cell }) => {
                            const value = cell.getValue()
                            return <span>{value}</span>
                          },
                        },
                        {
                          accessorKey: "clidirec",
                          header: "Dirección",
                          size: 400,
                          Cell: ({ cell }) => {
                            const value = cell.getValue()
                            return <p>{value}</p>
                          },
                        },
                        {
                          accessorKey: "clireferencia1",
                          header: "Referencia Rápida",
                          size: 120,
                          Cell: ({ cell }) => {
                            const value = cell.getValue()
                            return <p>{value}</p>
                          },
                        },
                        {
                          accessorKey: "zoncodigo",
                          header: "Zona",
                          size: 120,
                          Cell: ({ cell }) => {
                            const value = cell.getValue()
                            return <span>{value}</span>
                          },
                        },
                        {
                          accessorKey: "clistatus",
                          header: "Estado",
                          size: 120,
                          Cell: ({ cell }) => {
                            const value = cell.getValue()
                            if (value === "A") return "Activo"
                            if (value === "I") return "Inactivo"
                            return <span>{value}</span>
                          },
                        },
                      ]}
                      errorMsg="Error al cargar los datos de clientes"
                    ></ModalSearchClient>
                    {/* *****************************************************
                                   MODAL CREAR CLIENTE
                  ****************************************************** */}

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        width: "100%",
                      }}
                    >
                      <div style={{ textAlign: "left" }}>
                        <Modal
                          open={openModalCreateClient}
                          onClose={handleCloseModalCreateClient}
                          aria-labelledby="parent-modal-title"
                          aria-describedby="parent-modal-description"
                        >
                          <Box>
                            <ModalCreateClient
                              handleCloseModalCreateClient={handleCloseModalCreateClient}
                              setCabeceraProforma={setCabeceraProforma}
                              cabeceraProforma={cabeceraProforma}
                            />
                          </Box>
                        </Modal>
                      </div>
                    </div>
                  </Cliente>
                  <Direccion>
                    <CustomTextFieldReadable
                      placeholder="Direccion"
                      value={direccionCliente ?? ""}
                    ></CustomTextFieldReadable>
                  </Direccion>
                  <Telefono>
                    <CustomTextFieldReadable
                      placeholder="Telefono"
                      value={telefonoCliente ?? ""}
                    ></CustomTextFieldReadable>
                  </Telefono>
                  <Id>
                    <CustomTextFieldReadable placeholder="Id" value={idCliente ?? ""}></CustomTextFieldReadable>
                  </Id>
                </ContainerCliente>
              </AccordionDetails>
            </Accordion>
          </div>
          <div style={{ paddingBottom: "10px" }}>
            <Accordion
              expanded={expanded1}
              onChange={handleExpandAccordion1}
              slotProps={{ heading: { component: "h2" } }}
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                style={styles.accordionSummary}
              >
                <Typography variant="h6" style={{ width: "100%", textAlign: "center" }}>
                  Datos de Garante
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <ContainerGarante>
                  <Garante>
                    <CustomHelperDetail
                      label="Garante"
                      valueSearched={filtros.garante?.clicodigo}
                      endpoint="/AsociacionProdAgencia/getCliente"
                      valueInputMain="clicodigo"
                      valueInputSecondary="clinombre"
                      thirdInputValue="cliruc"
                      fourthInputValue="clitelef1"
                      idSearchField="clicodigo"
                      errorMsgIdSearch="Error fetching data:"
                      errorMsgFilterSearch="Error en cargar datos"
                      queryKeyModal="GaranteVentaProforma"
                      perPage={10}
                      placeholderInputMain="Garante"
                      placeholderInputSecondary="Nombre"
                      placeholderThirdInput="Identificacion"
                      placeholderFourthInput="Telefono"
                      columnsTable={[
                        {
                          accessorKey: "ciacodigo",
                          header: "Ciacodigo",
                          size: 100,
                          Cell: ({ cell }) => {
                            const value = cell.getValue()
                            return <span>{value}</span>
                          },
                        },
                        {
                          accessorKey: "clicodigo",
                          header: "Código de Cliente",
                          size: 100,
                          Cell: ({ cell }) => {
                            const value = cell.getValue()
                            return <span>{value}</span>
                          },
                        },
                        {
                          accessorKey: "clinombre",
                          header: "Nombre del Cliente",
                          size: 250,
                          Cell: ({ cell }) => {
                            const value = cell.getValue()
                            return <span>{value}</span>
                          },
                        },
                        {
                          accessorKey: "cliruc",
                          header: "Número de identificación",
                          size: 150,
                          Cell: ({ cell }) => {
                            const value = cell.getValue()
                            return <span>{value}</span>
                          },
                        },
                        {
                          accessorKey: "clitelef1",
                          header: "Teléfono",
                          size: 100,
                          Cell: ({ cell }) => {
                            const value = cell.getValue()
                            return <span>{value}</span>
                          },
                        },
                        {
                          accessorKey: "clidirec",
                          header: "Dirección",
                          size: 400,
                          Cell: ({ cell }) => {
                            const value = cell.getValue()
                            return <p>{value}</p>
                          },
                        },
                        {
                          accessorKey: "clireferencia1",
                          header: "Referencia Rápida",
                          size: 120,
                          Cell: ({ cell }) => {
                            const value = cell.getValue()
                            return <p>{value}</p>
                          },
                        },
                        {
                          accessorKey: "zoncodigo",
                          header: "Zona",
                          size: 120,
                          Cell: ({ cell }) => {
                            const value = cell.getValue()
                            return <span>{value}</span>
                          },
                        },
                        {
                          accessorKey: "clistatus",
                          header: "Estado",
                          size: 120,
                          Cell: ({ cell }) => {
                            const value = cell.getValue()
                            if (value === "A") return "Activo"
                            if (value === "I") return "Inactivo"
                            return <span>{value}</span>
                          },
                        },
                      ]}
                      onHandleSelectedData={(v) => handleSetFiltros("garante", v)}
                      sxInputMain={{
                        minWidth: isMobile ? "100%" : "250px", // 100% en móvil, 170px en escritorio
                        maxWidth: isMobile ? "100%" : "250px",
                        marginRight: isMobile ? "0" : "10", // Sin margen en móvil, 10px en escritorio
                      }}
                      sxInputSecondary={{
                        width: "100%",
                      }}
                    />
                  </Garante>

                  <Integrador>
                    <TextField
                      required
                      fullWidth
                      label="Integrador"
                      variant="outlined"
                      value={filtros?.integrador?.integracodigo ?? ""}
                      InputProps={{
                        readOnly: true,

                        endAdornment: (
                          <div style={{ display: "flex" }}>
                            <Tooltip title="Buscar">
                              <IconButton
                                onClick={() => {
                                  handleOpenModalSearchIntegrador()
                                }}
                              >
                                <FcSearch />
                              </IconButton>
                            </Tooltip>

                            <Tooltip title="Crear">
                              <IconButton
                                aria-label="delete"
                                onClick={() => {
                                  handleOpenModalCreateIntegrador()
                                }}
                              >
                                <FcPlus />
                              </IconButton>
                            </Tooltip>
                          </div>
                        ),
                      }}
                    />
                    {/* *****************************************************
                                   MODAL BUSCAR Integrador
                  ****************************************************** */}
                    <ModalSearchIntegrador
                      endpoint="/facturacion_proformas/get_integra" // Ajusta este endpoint según tu backend
                      openModal={openModalSearchIntegrador}
                      handleCloseModal={handleCloseModalSearchIntegrador}
                      queryKey="integradorProformaSearchQuery"
                      perPage={10}
                      onItemSelected={handleIntegradorSelected}
                      columnsTable={[
                        {
                          accessorKey: "integracodigo",
                          header: "Codigo",
                          size: 100,
                          Cell: ({ cell }) => {
                            const value = cell.getValue()
                            return <span>{value}</span>
                          },
                        },
                        {
                          accessorKey: "integradescri",
                          header: "Descripcion",
                          size: 100,
                          Cell: ({ cell }) => {
                            const value = cell.getValue()
                            return <span>{value}</span>
                          },
                        },
                        {
                          accessorKey: "integradirecc",
                          header: "Direccion",
                          size: 250,
                          Cell: ({ cell }) => {
                            const value = cell.getValue()
                            return <span>{value}</span>
                          },
                        },
                        {
                          accessorKey: "integrafono",
                          header: "Teléfono",
                          size: 150,
                          Cell: ({ cell }) => {
                            const value = cell.getValue()
                            return <span>{value}</span>
                          },
                        },
                      ]}
                      errorMsg="Error al cargar los datos de integrador"
                    ></ModalSearchIntegrador>
                    {/* *****************************************************
                                   MODAL CREAR Integrador
                  ****************************************************** */}

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        width: "100%",
                      }}
                    >
                      <div style={{ textAlign: "left" }}>
                        <Modal
                          open={openModalCreateIntegrador}
                          onClose={handleCloseModalCreateIntegrador}
                          aria-labelledby="parent-modal-title"
                          aria-describedby="parent-modal-description"
                        >
                          <Box>
                            <ModalCreateIntegrador
                              handleCloseModalCreateIntegrador={handleCloseModalCreateIntegrador}
                              setCabeceraProforma={setCabeceraProforma}
                              cabeceraProforma={cabeceraProforma}
                            />
                          </Box>
                        </Modal>
                      </div>
                    </div>
                  </Integrador>
                  <Direccion>
                    <CustomTextFieldReadable
                      placeholder="Detalle"
                      value={filtros?.integrador?.integradescri ?? ""}
                    ></CustomTextFieldReadable>
                  </Direccion>
                  <Telefono>
                    <CustomTextFieldReadable
                      placeholder="Direccion"
                      value={filtros?.integrador?.integradirecc ?? ""}
                    ></CustomTextFieldReadable>
                  </Telefono>
                  <Id>
                    <CustomTextFieldReadable
                      placeholder="Telefono"
                      value={filtros?.integrador?.integrafono ?? ""}
                    ></CustomTextFieldReadable>
                  </Id>

                  <Proyecto>
                    <TextField
                      required
                      fullWidth
                      label="Proyecto"
                      variant="outlined"
                      value={filtros?.proyecto?.proyectocodigo ?? ""}
                      InputProps={{
                        readOnly: true,

                        endAdornment: (
                          <div style={{ display: "flex" }}>
                            <Tooltip title="Buscar">
                              <IconButton
                                onClick={() => {
                                  handleOpenModalSearchProyecto()
                                }}
                              >
                                <FcSearch />
                              </IconButton>
                            </Tooltip>

                            <Tooltip title="Crear">
                              <IconButton
                                aria-label="delete"
                                onClick={() => {
                                  handleOpenModalCreateProyecto()
                                }}
                              >
                                <FcPlus />
                              </IconButton>
                            </Tooltip>
                          </div>
                        ),
                      }}
                    />
                    {/* *****************************************************
                                   MODAL BUSCAR Integrador
                  ****************************************************** */}
                    <ModalSearchProyecto
                      endpoint="/facturacion_proformas/get_proyectos" // Ajusta este endpoint según tu backend
                      openModal={openModalSearchProyecto}
                      handleCloseModal={handleCloseModalSearchProyecto}
                      queryKey="proyectoProformaSearchQuery"
                      perPage={10}
                      onItemSelected={handleProyectoSelected}
                      columnsTable={[
                        {
                          accessorKey: "proyectocodigo",
                          header: "Codigo",
                          size: 100,
                          Cell: ({ cell }) => {
                            const value = cell.getValue()
                            return <span>{value}</span>
                          },
                        },
                        {
                          accessorKey: "proyectodescri",
                          header: "Descripcion",
                          size: 100,
                          Cell: ({ cell }) => {
                            const value = cell.getValue()
                            return <span>{value}</span>
                          },
                        },
                        {
                          accessorKey: "proyectodirecc",
                          header: "Direccion",
                          size: 250,
                          Cell: ({ cell }) => {
                            const value = cell.getValue()
                            return <span>{value}</span>
                          },
                        },
                        {
                          accessorKey: "proyectofono",
                          header: "Teléfono",
                          size: 150,
                          Cell: ({ cell }) => {
                            const value = cell.getValue()
                            return <span>{value}</span>
                          },
                        },
                      ]}
                      errorMsg="Error al cargar los datos de integrador"
                    ></ModalSearchProyecto>
                    {/* *****************************************************
                                   MODAL CREAR CLIENTE
                  ****************************************************** */}

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        width: "100%",
                      }}
                    >
                      <div style={{ textAlign: "left" }}>
                        <Modal
                          open={openModalCreateClient}
                          onClose={handleCloseModalCreateClient}
                          aria-labelledby="parent-modal-title"
                          aria-describedby="parent-modal-description"
                        >
                          <Box>
                            <ModalCreateClient
                              handleCloseModalCreateClient={handleCloseModalCreateClient}
                              setCabeceraProforma={setCabeceraProforma}
                              cabeceraProforma={cabeceraProforma}
                            />
                          </Box>
                        </Modal>
                      </div>
                    </div>
                  </Proyecto>
                  <DireccionProyecto>
                    <CustomTextFieldReadable
                      placeholder="Detalle"
                      value={filtros?.proyecto?.proyectodescri ?? ""}
                    ></CustomTextFieldReadable>
                  </DireccionProyecto>
                  <TelefonoProyecto>
                    <CustomTextFieldReadable
                      placeholder="Direccion"
                      value={filtros?.proyecto?.proyectodirecc ?? ""}
                    ></CustomTextFieldReadable>
                  </TelefonoProyecto>
                  <IdProyecto>
                    <CustomTextFieldReadable
                      placeholder="Telefono"
                      value={filtros?.proyecto?.proyectofono ?? ""}
                    ></CustomTextFieldReadable>
                  </IdProyecto>
                </ContainerGarante>
              </AccordionDetails>
            </Accordion>
          </div>
          <div style={{ paddingBottom: "10px" }}>
            <Accordion
              expanded={expanded2}
              slotProps={{ heading: { component: "h2" } }}
              onChange={handleExpandAccordion2}
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                style={styles.accordionSummary}
              >
                <Typography variant="h6" style={{ width: "100%", textAlign: "center" }}>
                  Datos de Transportista
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <ContainerTransportista>
                  <Transportista>
                    <CustomHelperDetail
                      label="Transportista"
                      valueSearched={filtros.transportista?.transcodigo}
                      endpoint="/facturacion_proformas/get_transportistas"
                      valueInputMain="transcodigo"
                      valueInputSecondary="transdescri"
                      thirdInputValue="transruc"
                      idSearchField="transcodigo"
                      errorMsgIdSearch="Error fetching data:"
                      errorMsgFilterSearch="Error en cargar datos"
                      queryKeyModal="transportistaVentaProforma"
                      perPage={10}
                      placeholderInputMain="Transportista"
                      placeholderInputSecondary="Nombre"
                      placeholderThirdInput="Identificacion"
                      columnsTable={[
                        {
                          accessorKey: "transcodigo",
                          header: "Codigo",
                          size: 100,
                          Cell: ({ cell }) => {
                            const value = cell.getValue()
                            return <span>{value}</span>
                          },
                        },
                        {
                          accessorKey: "transdescri",
                          header: "Descripcion",
                          size: 100,
                          Cell: ({ cell }) => {
                            const value = cell.getValue()
                            return <span>{value}</span>
                          },
                        },
                        {
                          accessorKey: "transdirec",
                          header: "Direccion",
                          size: 250,
                          Cell: ({ cell }) => {
                            const value = cell.getValue()
                            return <span>{value}</span>
                          },
                        },
                        {
                          accessorKey: "transruc",
                          header: "Identificacion",
                          size: 150,
                          Cell: ({ cell }) => {
                            const value = cell.getValue()
                            return <span>{value}</span>
                          },
                        },
                        {
                          accessorKey: "transtelef1",
                          header: "Telefono",
                          size: 100,
                          Cell: ({ cell }) => {
                            const value = cell.getValue()
                            return <span>{value}</span>
                          },
                        },
                        {
                          accessorKey: "transstaus",
                          header: "Estado",
                          size: 400,
                          Cell: ({ cell }) => {
                            const value = cell.getValue()
                            return <p>{value}</p>
                          },
                        },
                      ]}
                      onHandleSelectedData={(v) => handleSetFiltros("transportista", v)}
                      sxInputMain={{
                        minWidth: isMobile ? "100%" : "170px", // 100% en móvil, 170px en escritorio
                        maxWidth: isMobile ? "100%" : "170px",
                        marginRight: isMobile ? "0" : "10px", // Sin margen en móvil, 10px en escritorio
                      }}
                      sxInputSecondary={{
                        width: "100%",
                      }}
                    ></CustomHelperDetail>
                  </Transportista>
                  <DireccionEntrega>
                    <CustomAutocomplete
                      options={dataAgencias}
                      selectedOption={Object.keys(filtros.agencia).length > 0 ? filtros.agencia : ""}
                      setSelectedOption={(v) => {
                        handleSetFiltros("agencia", v)
                      }}
                      label={"Direccion de Entrega"}
                    />
                  </DireccionEntrega>
                </ContainerTransportista>
              </AccordionDetails>
            </Accordion>
          </div>
          <br></br>
          <br></br>
          <ContainerTab>
            <TabI id="productos">
              <div style={styles.tabsContainer}>
                <div style={styles.tabButtons}>
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    orientation={isMobile ? "vertical" : "horizontal"} // Vertical layout on mobile
                    variant={isMobile ? "scrollable" : "standard"} // Scrollable on mobile
                    sx={{
                      width: isMobile ? "100%" : "auto", // Full width on mobile
                      display: "flex",
                      flexDirection: isMobile ? "column" : "row", // Stack tabs vertically on mobile
                      ...styles.tabButton,
                    }}
                  >
                    <Tab
                      label="Detalle"
                      sx={{
                        ...styles.tabButton,
                        ...(value === 0 && styles.activeTab),
                        color: value === 0 ? "white" : "#000",
                        "&.Mui-selected": {
                          color: "white", // Color blanco para el texto cuando el tab está seleccionado
                          backgroundColor: "rgb(25, 108, 135)", // Asegura que el fondo del tab activo esté visible
                        },
                      }}
                    />
                    <Tab
                      label="Otros Datos del Cliente"
                      sx={{
                        ...styles.tabButton,
                        ...(value === 1 && styles.activeTab),
                        color: value === 1 ? "white" : "#000",
                        "&.Mui-selected": {
                          color: "white",
                          backgroundColor: "rgb(25, 108, 135)",
                        },
                      }}
                    />
                    <Tab
                      label="Cartera"
                      sx={{
                        ...styles.tabButton,
                        ...(value === 2 && styles.activeTab),
                        color: value === 2 ? "white" : "#000",
                        "&.Mui-selected": {
                          color: "white",
                          backgroundColor: "rgb(25, 108, 135)",
                        },
                      }}
                    />
                    <Tab
                      label="Cobro"
                      sx={{
                        ...styles.tabButton,
                        ...(value === 3 && styles.activeTab),
                        color: value === 3 ? "white" : "#000",
                        "&.Mui-selected": {
                          color: "white",
                          backgroundColor: "rgb(25, 108, 135)",
                        },
                      }}
                    />
                  </Tabs>
                </div>

                <div style={styles.tabContent}>
                  {value === 0 && (
                    <>
                      <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
                        <Obturador
                          scannerParams={{
                            msg: "Escanea el código de barras",
                            codeType: "bar",
                          }}
                          executeFunction={textIsAlreadyDecodedUbicacion}
                          shouldHideButton={true}
                          onTextFieldChange={setValorBusqueda}
                        />
                        <CustomTooltip title={"Buscar"}>
                          <Button style={{ fontSize: "0.9vw" }} onClick={handleSearchByCodigo}>
                            <img src={EjecutarAccionIcon} alt="Crear" style={{ width: "40px" }} />
                          </Button>
                        </CustomTooltip>
                      </Box>

                      <br></br>
                      <DetallesTab
                        productos={prods}
                        setProductosSeleccionados={setProductosSeleccionados}
                        productosSeleccionados={productosSeleccionados}
                        inputName="artdescri"
                        inputCodigo="artcodigo"
                        inputPrecio="precioUnitario"
                        inputImage="imagen"
                      ></DetallesTab>
                    </>
                  )}
                  {value === 1 && (
                    <div>
                      <div style={styles.subtabsContainer}>
                        <StyledTabs
                          sx={{ display: "flex", flexWrap: "wrap" }}
                          value={valueTab}
                          onChange={handleTabChange}
                        >
                          <StyledTab sx={{ flex: 1 }} label="Datos Adicionales del Cliente" />
                          <StyledTab sx={{ flex: 1 }} label="Datos para Otorgar el Crédito" />
                        </StyledTabs>
                      </div>
                      <Box sx={styles.tabPanel}>
                        {valueTab === 0 && (
                          <div>
                            <br></br>
                            <CustomerAdditionalInfo />
                          </div>
                        )}

                        {valueTab === 1 && (
                          <div>
                            <br></br>
                            <CreditGrantingInfo />
                          </div>
                        )}
                      </Box>
                    </div>
                  )}
                  {value === 2 && (
                    <div>
                      <PaymentScreen />
                    </div>
                  )}
                  {value === 3 && (
                    <div>
                      <PaymentDetailsScreen />
                    </div>
                  )}
                </div>
              </div>
            </TabI>

            {isMobile && (
              <>
                <Fab
                  color="primary"
                  aria-label="shopping-cart"
                  onClick={handleOpenPedidoModal}
                  sx={{
                    position: "fixed",
                    bottom: 16,
                    right: 16,
                    zIndex: 11000,
                  }}
                >
                  <ShoppingCartIcon />
                </Fab>

                <Modal open={openPedidoModal} onClose={handleClosePedidoModal}>
                  <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: "90%",
                      maxWidth: "400px",
                      bgcolor: "background.paper",
                      boxShadow: 24,
                      p: 2,
                    }}
                  >
                    <ShoppingDetail
                      productosSeleccionados={productosSeleccionados}
                      setProductosSeleccionados={setProductosSeleccionados}
                    />
                  </Box>
                </Modal>
              </>
            )}

            {/* Display Pedido normally on larger screens */}
            {!isMobile && (
              <Pedido>
                <ShoppingDetail
                  productosSeleccionados={productosSeleccionados}
                  setProductosSeleccionados={setProductosSeleccionados}
                />
              </Pedido>
            )}
          </ContainerTab>
        </Box>
      </div>
    </ThemeProvider>
  )
}
export default ProductosServicios
